export default "__VITE_ASSET__DeHskv7I__"